import { render, staticRenderFns } from "./external-employee.vue?vue&type=template&id=56fb325b&"
import script from "./external-employee.vue?vue&type=script&lang=js&"
export * from "./external-employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports